import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

interface PolicyAction {
    id: string;
    label: string;
    params?: any;
    followup_message?: string;
}

interface AgentDetailsCardProps {
    card: any;
    onAction?: (action: PolicyAction) => void;
}

const AgentDetailsCard: React.FC<AgentDetailsCardProps> = ({ card }) => {
    if (!card) return null;

    const items = (card?.sections?.[0]?.items || []).filter(Boolean);

    const getIconForLabel = (label: string) => {
        const lowerLabel = label.toLowerCase();
        if (lowerLabel.includes('name') || lowerLabel.includes('agent')) {
            return <PersonIcon sx={{ fontSize: { xs: 16, md: 18 }, color: '#6b7280' }} />;
        } else if (lowerLabel.includes('email') || lowerLabel.includes('mail')) {
            return <EmailIcon sx={{ fontSize: { xs: 16, md: 18 }, color: '#6b7280' }} />;
        } else if (lowerLabel.includes('phone') || lowerLabel.includes('contact') || lowerLabel.includes('mobile')) {
            return <PhoneIcon sx={{ fontSize: { xs: 16, md: 18 }, color: '#6b7280' }} />;
        }
        return null;
    };

    return (
        <Paper
            elevation={0}
            sx={{
                width: { xs: "100%", md: "100%" },
                border: "1px solid #e5e7eb",
                borderRadius: { xs: 1, md: 2 },
                p: { xs: 1.25, md: 2 },
                bgcolor: "#ffffff",
            }}
        >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                {card?.title && (
                    <Typography sx={{ fontWeight: 700, fontSize: { xs: 12, md: 14 } }}>
                        {card.title}
                    </Typography>
                )}

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1.25,
                    }}
                >
                    {items.map((item: any, idx: number) => (
                        <Box
                            key={`agent_detail_${idx}`}
                            sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                            {getIconForLabel(item?.label)}
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    fontSize: { xs: 12, md: 14 },
                                    color: "#374151",
                                    minWidth: { xs: 70, md: 90 },
                                }}
                            >
                                {item?.label} :
                            </Typography>
                            <Typography sx={{ fontSize: { xs: 12, md: 14 }, color: "#111827" }}>
                                {item?.value || "-"}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Paper>
    );
};

export default AgentDetailsCard;


